import axios from "axios";
const back_url = process.env.REACT_APP_BACKEND_URL;
const token = localStorage.getItem("token");
const apiClient = axios.create({
  baseURL: back_url,
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default apiClient;

export const generateReportAPI = async (payload: any) => {
  try {
    const response = await apiClient.post("/report/generate", payload);
    if (response.data && response.data.status === "success") {
      return response;
    } else {
      console.error("Creating report failed with status:", response);
    }
  } catch (err) {
    console.error("Error during creating report :", err);
    throw err; // Optionally re-throw to handle the error in the component
  }
};

export const saveReport = async (payload: any) => {
  try {
    const response = await apiClient.post("/report/save-report", payload);
    if (response.data && response.data.status === "success") {
      return response;
    } else {
      console.error("Creating report failed with status:", response);
    }
  } catch (err) {
    console.error("Error during creating report :", err);
    throw err; // Optionally re-throw to handle the error in the component
  }
};

export const updateReport = async (payload: any) => {
  try {
    const response = await apiClient.post("/report/update-report", payload);
    if (response.data && response.data.status === "success") {
      return response;
    } else {
      console.error("Creating report failed with status:", response);
    }
  } catch (err) {
    console.error("Error during creating report :", err);
    throw err; // Optionally re-throw to handle the error in the component
  }
};

export const getImage = async (payload: any) => {
  try {
    const response = await apiClient.post("/report/get-images", payload);
    if (response?.data && response?.status === 200) {
      return {
        width: response.data?.width,
        height: response.data?.height,
        imageUrl: response.data?.imageData,
        type: response.data?.type,
      };
    } else {
      // console.error("Creating report failed with status:", response);
    }
  } catch (err) {
    // console.error("Error during creating report :", err);
    // throw err; // Optionally re-throw to handle the error in the component
  }
};

export const updateReportAPI = async (reportId: string, payload: any) => {
  try {
    const response = await apiClient.post(
      `/report/update/${reportId}`,
      payload
    );

    if (response.data && response.data.status === "success") {
      return response;
    } else {
      console.error("Updating report failed with status:", response);
    }
  } catch (err) {
    console.error("Error during updating report :", err);
    throw err; // Optionally re-throw to handle the error in the component
  }
};

export const getReportListAPI = async () => {
  try {
    const response = await apiClient.get(`/report/list`);
    if (response.data && response.data.status === "success") {
      return response.data.payload; // This should now include pagination info
    }
  } catch (error) {
    console.error("Error fetching reports:", error);
    return { reports: [], total_reports: 0, total_items: 0, current_report: 1 };
  }
};

export const getReportData = async (payload: any) => {
  try {
    const response = await apiClient.post(`/report/get-report-data`, payload);
    if (response.data && response.data.status === "success") {
      return response;
    }
  } catch (error) {
    console.error("Error fetching reports:", error);
    return;
  }
};

export const downloadReportPDF = async (payload: any) => {
  try {
    const response = await apiClient.post(`/report/download-report`, payload);
    if (response.data && response.data.status === "success") {
      return response;
    }
  } catch (error) {
    console.error("Error fetching reports:", error);
    return;
  }
};

export const onlyDownloadReportPDF = async (payload: any) => {
  try {
    const response = await apiClient.post(
      `/report/only-download-report`,
      payload,
      {
        responseType: "blob",
      }
    );
    return response;
  } catch (error) {
    console.error("Error fetching reports:", error);
    return;
  }
};

export const generateSummary = async (payload: any) => {
  try {
    const response = await apiClient.post(`/report/generate_summary`, payload);
    return response;
  } catch (error) {
    console.error("Error fetching reports:", error);
    return;
  }
};

export const uploadLogo = async (logo: any) => {
  try {
    const response = await apiClient.post(`/report/upload-logo`, logo, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    if (response.data && response.data.status === "success") {
      return response;
    }
  } catch (error) {
    console.error("Error fetching reports:", error);
    return;
  }
};

export const getSingleReportAPI = async (
  reportId: string | undefined,
  viewMode: boolean
) => {
  try {
    if (!reportId) return [];
    const response = await apiClient.get(
      `/report/single/${reportId}?view_mode=${viewMode ? "true" : ""}`
    );
    if (response.data && response.data.status === "success") {
      return response.data.payload;
    }
  } catch (error) {
    console.error("Error fetching personal images:", error);
    return [];
  }
};

export const uploadDocumentAPI = async (formData: any) => {
  try {
    const response = await apiClient.post("/report/upload_document", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    if (response.data && response.data.status === "success") {
      return response; // This now correctly returns the template filename
    } else {
      console.error("Uploading failed with status:", response);
    }
  } catch (err) {
    console.error("Error during uploading:", err);
    throw err; // Optionally re-throw to handle the error in the component
  }
};

export const deleteDocumentAPI = async (payload: any) => {
  try {
    const response = await apiClient.post(`/report/delete_document`, payload);
    return response;
  } catch (error) {
    console.error("Error fetching reports:", error);
    return;
  }
};

export const fetchPatientDocuments = async (patientId: string) => {
  try {
    const response = await apiClient.get(`/report/get_documents/${patientId}`);
    return response?.data?.documents;
  } catch (err) {
    console.error("Failed to fetch documents", err);
    throw err;
  }
};

export const deleteReportAction = async (reportId: any) => {
  try {
    const response = await apiClient.delete(`/report/delete/${reportId}`);
    if (response.data && response.data.status === "success") {
      return response;
    }
  } catch (error) {
    console.error("Error fetching personal reports:", error);
  }
};

export const generateQRCodeAPI = async (reportId: string): Promise<Blob> => {
  try {
    const response = await apiClient.get(`/report/generate_qr/${reportId}`, {
      responseType: "blob",
    });
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Failed to generate QR code: status ${response.status}`);
    }
  } catch (error) {
    console.error("Error during QR code generation:", error);
    throw error; // Rethrow to handle it in the component
  }
};
